/**
 * Centralized Coin Configuration
 * 
 * This file is auto-generated from shared/coins.config.js
 * DO NOT EDIT THIS FILE DIRECTLY - make changes in shared/coins.config.js instead
 */
const supportedCoins = [
  {
    "name": "Bitcoin",
    "symbol": "BTC",
    "code": "btcusd",
    "displayName": "BTC/USD",
    "baseCurrency": "BTC",
    "quoteCurrency": "USD",
    "priceDecimals": 2,
    "quantityDecimals": 8,
    "precision": 8,
    "step": 1e-8,
    "min": 1e-8,
    "minTradeSize": 0.00001,
    "initialAmount": 10,
    "hasFullHistory": true,
    "enabled": true,
    "borrowRate": 0.05,
    "riskProfile": "Low volatility, high liquidity"
  },
  {
    "name": "Ethereum",
    "symbol": "ETH",
    "code": "ethusd",
    "displayName": "ETH/USD",
    "baseCurrency": "ETH",
    "quoteCurrency": "USD",
    "priceDecimals": 2,
    "quantityDecimals": 8,
    "precision": 8,
    "step": 1e-8,
    "min": 1e-8,
    "minTradeSize": 0.0001,
    "initialAmount": 0,
    "hasFullHistory": true,
    "enabled": true,
    "borrowRate": 0.06,
    "riskProfile": "Low volatility, high liquidity"
  },
  {
    "name": "Ripple",
    "symbol": "XRP",
    "code": "xrpusd",
    "displayName": "XRP/USD",
    "baseCurrency": "XRP",
    "quoteCurrency": "USD",
    "priceDecimals": 4,
    "quantityDecimals": 1,
    "precision": 6,
    "step": 0.000001,
    "min": 0.000001,
    "minTradeSize": 1,
    "initialAmount": 0,
    "hasFullHistory": true,
    "enabled": true,
    "borrowRate": 0.08,
    "riskProfile": "Medium volatility"
  },
  {
    "name": "Solana",
    "symbol": "SOL",
    "code": "solusd",
    "displayName": "SOL/USD",
    "baseCurrency": "SOL",
    "quoteCurrency": "USD",
    "priceDecimals": 2,
    "quantityDecimals": 9,
    "precision": 9,
    "step": 1e-9,
    "min": 1e-9,
    "minTradeSize": 1e-9,
    "initialAmount": 0,
    "hasFullHistory": true,
    "enabled": true,
    "borrowRate": 0.1,
    "riskProfile": "Medium-high volatility"
  },
  {
    "name": "Dogecoin",
    "symbol": "DOGE",
    "code": "dogeusd",
    "displayName": "DOGE/USD",
    "baseCurrency": "DOGE",
    "quoteCurrency": "USD",
    "priceDecimals": 5,
    "quantityDecimals": 2,
    "precision": 8,
    "step": 1e-8,
    "min": 1e-8,
    "minTradeSize": 1,
    "initialAmount": 0,
    "hasFullHistory": false,
    "enabled": true,
    "borrowRate": 0.15,
    "riskProfile": "High volatility, meme coin"
  },
  {
    "name": "Cardano",
    "symbol": "ADA",
    "code": "adausd",
    "displayName": "ADA/USD",
    "baseCurrency": "ADA",
    "quoteCurrency": "USD",
    "priceDecimals": 4,
    "quantityDecimals": 6,
    "precision": 6,
    "step": 0.000001,
    "min": 0.000001,
    "minTradeSize": 1,
    "initialAmount": 0,
    "hasFullHistory": true,
    "enabled": true,
    "borrowRate": 0.07,
    "riskProfile": "Medium volatility"
  },
  {
    "name": "Avalanche",
    "symbol": "AVAX",
    "code": "avaxusd",
    "displayName": "AVAX/USD",
    "baseCurrency": "AVAX",
    "quoteCurrency": "USD",
    "priceDecimals": 4,
    "quantityDecimals": 6,
    "precision": 6,
    "step": 0.000001,
    "min": 0.000001,
    "minTradeSize": 0.01,
    "initialAmount": 0,
    "hasFullHistory": false,
    "enabled": true,
    "borrowRate": 0.12,
    "riskProfile": "High volatility"
  }
];

// Utility functions
const getCoinBySymbol = (symbol) => supportedCoins.find(c => c.symbol.toLowerCase() === symbol.toLowerCase());
const getCoinByCode = (code) => supportedCoins.find(c => c.code.toLowerCase() === code.toLowerCase());
const getEnabledCoins = () => supportedCoins.filter(c => c.enabled);
const getLimitedHistoryCoins = () => supportedCoins.filter(c => !c.hasFullHistory).map(c => c.symbol.toUpperCase() + 'USD');

// Export for ES modules (frontend)
export {
  supportedCoins,
  getCoinBySymbol,
  getCoinByCode,
  getEnabledCoins,
  getLimitedHistoryCoins
};

// Export for CommonJS (Node.js backend)
if (typeof module !== 'undefined' && module.exports) {
  module.exports = {
    supportedCoins,
    getCoinBySymbol,
    getCoinByCode,
    getEnabledCoins,
    getLimitedHistoryCoins
  };
}